

























































































































































import PosterUser from "../mixins/poster-user";
import Worker from "./Worker.vue";
import InputDialog from "./InputDialog.vue";
import ReloadButton from "@/components/ReloadButton.vue";
import StatusChip from "@/components/StatusChip.vue";
import { mapState } from "vuex";
import { EvalPreinscripcionForm } from "../services/poster";
import Swal from "sweetalert2";

export default PosterUser.extend({
  components: {
    Worker,
    InputDialog,
    ReloadButton,
    StatusChip,
  },

  props: {
    revisor: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    posterType: "eval",
    preaceptado: null as boolean | null,
    tipo_aceptacion: null as any,
    observacion: null as any,
    animation: 0,
    dialog_: true,
  }),

  computed: {
    ...mapState("session", ["usuario"]),
    form(): any {
      return {
        id_evaluador: this.usuario.id_participante,
        id_poster: this.poster?.id_poster,
        preaceptado: this.preaceptado,
        tipo_aceptacion: this.tipo_aceptacion,
        observacion: this.observacion,
      } as EvalPreinscripcionForm;
    },
    animationClass(): any {
      return {
        "poster-change-animation-sink": this.animation === 1,
        "poster-change-animation-rise": this.animation === 2,
      };
    },
    type() {
      return this.revisor ? "all" : "eval";
    },
  },

  methods: {
    aceptarponencia() {
      this.tipo_aceptacion = "PNC";
      (this as any).aceptar();
    },
    aceptarposter() {
      this.tipo_aceptacion = "PST";
      (this as any).aceptar();
    },
    aceptar() {
      this.preaceptado = true;
      (this as any).dialog();
    },

    rechazar() {
      this.preaceptado = false;
      (this as any).dialog();
    },

    async dialog() {
      const { isConfirmed, value } = await Swal.fire({
        title: "Observación",
        input: "textarea",
        showCancelButton: true,
        inputValue: this?.poster?.evaluacion?.observacion,
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        customClass: "swal-observacion" as any,
        inputValidator: (value: any) => {
          return value.length >= 2000 && "Solo dispones de 2000 caracteres";
        },
      } as any);
      if (isConfirmed) {
        this.observacion = value;
        (this as any).save();
      }
    },

    async save() {
      const { form, poster } = this;
      try {
        await this.$store.dispatch("poster/evalPreinscripcionPoster", {
          form,
          poster,
        });
      } catch (err) {
        return;
      }
      this.animation = 1;
      this.observacion = null;
    },

    onAnimationEnd() {
      if (this.animation === 1) {
        this.next();
        this.animation = 2;
      }
    },
  },

  created() {
    this.bindPosterType("type");
  },
});
